import type { SendStatus } from '@emailforge/schemas';

import { apiSlice } from '@/features/api/apiSlice';

export type SendEventRow = {
  id: string;
  templateSlug: string | null;
  templateName: string | null;
  providerMessageId: string | null;
  recipientHash: string;
  status: SendStatus;
  latencyMs: number | null;
  /** Echo of the idempotency key the caller provided (or auto-generated). */
  idempotencyKey: string | null;
  /** Error reason set by the worker on failed sends. */
  error: string | null;
  occurredAt: string;
};

export type SendStats = {
  delivered: number;
  opened: number;
  clicked: number;
  bounced: number;
  deferred: number;
};

export const sendsApi = apiSlice.injectEndpoints({
  endpoints: (b) => ({
    listSends: b.query<SendEventRow[], { limit?: number; cursor?: string } | void>({
      query: (arg) => {
        const params = new URLSearchParams();
        if (arg?.limit) params.set('limit', String(arg.limit));
        if (arg?.cursor) params.set('cursor', arg.cursor);
        return `/sends?${params.toString()}`;
      },
      providesTags: ['Send'],
    }),
    sendsStats: b.query<SendStats, void>({
      query: () => '/sends/stats',
      providesTags: ['Send'],
    }),
    sendTest: b.mutation<
      { sendEventId: string; queued: true },
      { templateId: string; to: string; variables?: Record<string, unknown> }
    >({
      query: ({ templateId, ...body }) => ({
        url: `/send/${templateId}`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Send'],
    }),
  }),
});

export const { useListSendsQuery, useSendsStatsQuery, useSendTestMutation } = sendsApi;
